module.exports = __webpack_public_path__ + "static/media/SG-DektopImg.36151cec.png";